interface Types {
  SET_TRIED_COUNT: string
  INCREMENT_TRIED_COUNT: string
}

export const types: Types = {
  SET_TRIED_COUNT: 'SET_TRIED_COUNT',
  INCREMENT_TRIED_COUNT: 'INCREMENT_TRIED_COUNT',
};
